import { useContext } from "react";
import { OnboardingContext } from "../context/OnboardingContext";

export default function Step14Limits() {
  const { setCurrentStep } = useContext(OnboardingContext);

  function continueNext() {
    setCurrentStep("legal");
  }

  return (
    <div>
      <h2>Resource Allocation</h2>

      <p>Your organization will begin with the following resource limits:</p>

      <ul>
        <li><strong>Max vCPU:</strong> 16</li>
        <li><strong>Max Memory:</strong> 64 GB</li>
        <li><strong>Max Concurrent Users:</strong> 3</li>
      </ul>

      <p>
        These defaults are sufficient for most organizations.  
        You may request changes later by logging into the CloudGenomics Admin Portal.
      </p>

      <button onClick={continueNext}>Continue</button>
    </div>
  );
}
